import { PrivacyPolicyService, toastr, PRIVACY_POLICY, CustomToastrAction, REDIRECT, TRANSLATION } from '@/imports-files/pages/clients/data-privacy/privacy-policy';


export class PrivacyPolicyAction
{
  constructor(setApiError)
  {
    this.privacyPolicyService   =   new PrivacyPolicyService();
    this.setApiError            =   setApiError;
    this.customToastrAction     =   new CustomToastrAction(); 
  }

  async getPrivacyPolicy(router)
  {
    var body      =  {step: router.query.step}
     var result = await this.privacyPolicyService.getPrivacyPolicy(body);
     this.setApiError(result.request);
     return result.data;
  }

  async submitData(values, setIntitalData, router, quick_setup)
  {
    var body  = values;
    if(quick_setup) { body.quick_setup = quick_setup }
    var result = await this.privacyPolicyService.submitPolicy(body);
    this.setApiError(result.request);
    this.customToastrAction.setNormalToastr(result.data.success || TRANSLATION('toastr:policy_update'), 'success');
    if(result.data.next_step)
    {
        let next_step = result.data.next_step
        let url = `${REDIRECT.client.quick_setup}${next_step}`;
        (next_step == 'complete') ? router.push(REDIRECT.client.activities) : router.push(url)
    }
    setIntitalData(result.data.policy);
  }

  async generatePolicyData(values, setIntitalData,router, quick_setup, setPolicyDataForm, setPrivacyPolicyForm, formik)
  {
    var body  = values;
    if(quick_setup) { body.quick_setup = quick_setup }
    var result = await this.privacyPolicyService.generatePolicy(body);
    // result.data.policy.terms_accepted = result.data.policy.terms_accepted_at ? true : false
    await setIntitalData(result.data.policy);
    await setPolicyDataForm(false);
    await setPrivacyPolicyForm(true);
  }

  async onPrivacyPolicyChange(event, formik){
    let value = event.target.value
    if(value == "true"){
      await formik.setFieldValue('candidly_template', true)
      await formik.setFieldValue('description', formik.values.policy_template)
    }
    else{
      await formik.setFieldValue('candidly_template', false)
      await formik.setFieldValue('terms_accepted', false)
      await formik.setFieldValue('description', "")
    }
  }
}